import { Injectable } from '@angular/core';

export interface EnvConfig {
  BASE_URL: string;
  S3_BASE_URL: string;
  CONCIERGE_URL: string;
  RBAC_URL: string;
  DOREMON_URL: string;
  DOREMON_DOC_KEY: string;
}

declare global {
  interface Window {
    env: EnvConfig;
  }
}

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private config: any = {};

  constructor() {
    this.initializeConfig();
  }

  private initializeConfig(): void {
    
    if (typeof window !== 'undefined' && window.env) {
      this.config = {
        ...this.config,
        ...window.env
      };
    }
  }

  getBaseUrl(): string {
    return this.config.BASE_URL;
  }

  getRbacUrl(): string {
    return this.config.RBAC_URL;
  }

  getDoremonUrl(): string {
    return this.config.DOREMON_URL;
  }

  get doremonDocKey(): string{
    return this.config.DOREMON_DOC_KEY;
  }

  getConciergeUrl(): string {
    return this.config.CONCIERGE_URL;
  }
} 